const smsHistory = {
  firestorePath: '/smsHistory',
  firestoreRefType: 'collection',
  moduleName: 'smsHistory',
  statePropName: 'smsHistory',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%',
      updated_at: '%convertTimestamp%'
    }
  },
  getters: {
    getSmsHistory: (state) => {
      return _.toArray(state.smsHistory);
    },
    getSms: (state) => (id) => {

      return state.smsHistory(id);
    }

  },
  mutations: {},
  actions: {},
  sync: {
    debounceTimerMs: 1,
    fillables: [], // array of  keys
    guard: ['created_by'] // array of keys
  }
};

export default smsHistory;